module.exports = __webpack_public_path__ + "static/media/sf_2900_gray.7a05e22f84aef0e907e6c0727c7e3f41.png";